import { render } from "./LatestTransaction.vue?vue&type=template&id=34f38f2c&scoped=true&ts=true"
import script from "./LatestTransaction.vue?vue&type=script&lang=ts"
export * from "./LatestTransaction.vue?vue&type=script&lang=ts"

import "./LatestTransaction.vue?vue&type=style&index=0&id=34f38f2c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f38f2c"]])

export default __exports__